import { HttpErrorResponse } from '@angular/common/http';
import { ErrorMessages } from '../../shared/models/message.model';

/**
 * Mapuje odpowiedzi błędów endpointów 2FA na komunikaty dla użytkownika.
 */
export function twoFactorErrorMessage(error: HttpErrorResponse, fallback: string): string {
  const message = error && error.error ? error.error.message : undefined;

  if (error && error.status === 429) {
    const retryAfter = error.error && error.error.retryAfter ? Number(error.error.retryAfter) : 0;
    const minutes = Math.max(1, Math.ceil(retryAfter / 60));
    return `Zbyt wiele nieudanych prób. Spróbuj ponownie za ${minutes} min.`;
  }

  switch (message) {
    case ErrorMessages.InvalidTwoFactorCode:
      return 'Nieprawidłowy kod uwierzytelniający';
    case ErrorMessages.TwoFactorAlreadyEnabled:
      return 'Uwierzytelnianie dwuskładnikowe jest już włączone';
    case ErrorMessages.TwoFactorEnforced:
      return 'Uwierzytelnianie dwuskładnikowe jest wymagane i nie może zostać wyłączone';
    case ErrorMessages.TwoFactorNotEnabled:
      return 'Uwierzytelnianie dwuskładnikowe nie jest włączone';
    default:
      return fallback;
  }
}

/** Czy błąd oznacza nieważny/wygasły token challenge (5 min od podania hasła). */
export function isChallengeExpired(error: HttpErrorResponse): boolean {
  return !!(error && error.error && error.error.message === ErrorMessages.InvalidChallengeToken);
}
